import { getAxiosInstance } from "./reservation";

export const desinscribirDeCurso = async (idAlumnoPrograma: number, idCurso: number, anioLectivo: number) => {
  try {
    const { data, status } = await getAxiosInstance(idAlumnoPrograma).post("/api/bajaInscripcionAMateria", {
      curso: idCurso,
      aL: anioLectivo,
    });
    return { data, status };
  } catch (error) {
    return { data: null, status: 401 };
  }
};

export const validarDesinscribirDeCurso = async (idAlumnoPrograma: number, idCurso: number, anioLectivo: number) => {
  const { data, status } = await getAxiosInstance(idAlumnoPrograma).post("/api/validarDesinscribirDeCurso", {
    idCurso,
    anioLectivo,
  });
  return { data, status };
};

export const registrarRecepcionTx = async (idAlumnoPrograma: number, idTx: number, fechaRecepcion: string) => {
  const { data, status } = await getAxiosInstance(idAlumnoPrograma).post("/api/registrarRecepcionTx", {
    idTx,
    fechaRecepcion,
  });
  return { data, status };
};
